/**
 * Cart Drawer - Vanilla JS Version
 * Mesma funcionalidade e visual da versão Vue, sem dependências.
 */

if (typeof window.CartDrawerInitialized === 'undefined') {
    window.CartDrawerInitialized = true;
  
  // ============================================================================
  // CONSTANTS
  // ============================================================================
  
  const SUBSCRIPTION_SKUS = ['7U01ASSI30D', '7U01ASSI90D'];
  const SUBSCRIPTION_IDS = {
    monthly: 45467894087958,
    quarterly: 45467897594134
  };
  const DISCOUNT_CODES = {
    monthly: 'MULTIASSINATURA30',
    quarterly: 'MULTIASSINATURA90'
  };
  const TARGET_VARIANT_ID = 44134959350038;
  const PROMO_MULTI_COLLECTION_HANDLE = 'promo-multi';
  const REQUEST_TIMEOUT = 8000;
  const PROCESSING_SAFETY_TIMEOUT = 15000;

  let promoMultiVariantIds = null;
  let promoMultiProductIds = null;
  let promoMultiCatalogPromise = null;

  async function loadPromoMultiCatalog() {
    if (promoMultiVariantIds && promoMultiProductIds) {
      return { variantIds: promoMultiVariantIds, productIds: promoMultiProductIds };
    }

    if (!promoMultiCatalogPromise) {
      promoMultiCatalogPromise = (async () => {
        const variantIds = new Set();
        const productIds = new Set();
        let page = 1;

        while (true) {
          const response = await fetchWithTimeout(
            `/collections/${PROMO_MULTI_COLLECTION_HANDLE}/products.json?limit=250&page=${page}`
          );
          if (!response.ok) break;

          const data = await response.json();
          const products = data.products || [];
          if (products.length === 0) break;

          for (const product of products) {
            productIds.add(product.id);
            for (const variant of product.variants || []) {
              variantIds.add(variant.id);
            }
          }

          if (products.length < 250) break;
          page += 1;
        }

        promoMultiVariantIds = variantIds;
        promoMultiProductIds = productIds;
        return { variantIds, productIds };
      })().catch(error => {
        promoMultiCatalogPromise = null;
        console.error('Error loading Promo-Multi catalog:', error);
        return { variantIds: new Set(), productIds: new Set() };
      });
    }

    return promoMultiCatalogPromise;
  }

  function getItemVariantId(item) {
    return Number(item.variant_id || item.id);
  }

  function isPromoMultiCartItem(item) {
    const variantId = getItemVariantId(item);
    if (promoMultiVariantIds?.has(variantId)) return true;
    if (item.product_id && promoMultiProductIds?.has(item.product_id)) return true;
    return false;
  }

  function getMultiCartRedirectUrl(items) {
    if (!Array.isArray(items) || items.length === 0) return null;

    const hasPromoMultiItem = items.some(isPromoMultiCartItem);
    if (hasPromoMultiItem) return '/cart';

    const hasTargetVariant = items.some(item => getItemVariantId(item) === TARGET_VARIANT_ID);
    if (hasTargetVariant) return '/pages/cart-setyou';

    return null;
  }
  
  const UPSELL_PRODUCTS = [
    {
      product_id: 9669958271254,
      variant_id: 49023581290774,
      sku: '7U07PROCREA200POTE',
      title: 'Creatina com HMB',
      price: 12900,
      image: 'https://cdn.shopify.com/s/files/1/0276/6222/1377/files/creatinaimagem-1_45dcbcda-98a5-4258-a35a-d133cb82c134.png?v=1764260955&width=200'
    },
    {
      product_id: 10218080403734,
      variant_id: 50536739078422,
      sku: '7U07MIXBARRIGAFINA',
      title: 'Barriga Fina',
      price: 17990,
      image: 'https://cdn.shopify.com/s/files/1/0276/6222/1377/files/barrigafina.png?v=1760016085&width=200'
    },
    {
      product_id: 9966273134870,
      variant_id: 49987388211478,
      sku: '7U01SBBKERA150PURO',
      title: 'Keranat',
      price: 28900,
      image: 'https://cdn.shopify.com/s/files/1/0276/6222/1377/files/keranat-stevansite_d467805c-38dd-4a93-9b8b-f986480e48cd.png?v=1773867912&width=200'
    },
    {
      product_id: 10237720166678,
      variant_id: 50580216545558,
      sku: '7U07MIXYOUPOWER',
      title: 'You Power',
      price: 9990,
      image: 'https://cdn.shopify.com/s/files/1/0276/6222/1377/files/youpower_png.png?v=1765557628&width=200'
    },
    {
      product_id: 8792970363158,
      variant_id: 46755399172374,
      sku: '7U07MIXEMAG000VER',
      title: 'Multi Slim',
      price: 12900,
      image: 'https://cdn.shopify.com/s/files/1/0276/6222/1377/files/protocolo-multislim.png?v=1753909259&width=200'
    },
    {
      product_id: 10239104581910,
      variant_id: 50584036835606,
      sku: '7U08PRODDEEPSONO',
      title: 'Deep Dream',
      price: 12530,
      image: '//setyou.com.br/cdn/shop/files/DeepDream.png?v=1759944805&width=200'
    },
  ];
  
  // ============================================================================
  // CART DRAWER WEB COMPONENT
  // ============================================================================
  
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
  
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();
    }
  
    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) return;
  
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }
  
    async open(triggeredBy) {
      if (window.location.pathname.includes('/collections/compra-livre')) {
        window.location.href = '/pages/cart-setyou';
        return;
      }

      // Sempre busca o carrinho atual no servidor antes de abrir (evita estado stale entre abas)
      if (window.cartDrawerApp?.refreshCart) {
        await window.cartDrawerApp.refreshCart();
      }

      const redirectUrl = await this.getMultiCartRedirectUrl();
      if (redirectUrl) {
        window.location.href = redirectUrl;
        return;
      }

      if (triggeredBy) this.setActiveElement(triggeredBy);

      setTimeout(() => {
        this.classList.add('animate', 'active');
      });

      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('CartDrawer');
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
          if (typeof trapFocus !== 'undefined') {
            trapFocus(containerToTrapFocusOn, focusElement);
          }
        },
        { once: true }
      );

      document.body.classList.add('overflow-hidden');
    }

    async getMultiCartRedirectUrl() {
      await loadPromoMultiCatalog();

      if (window.cartDrawerApp?.getCartItems) {
        const redirectFromState = getMultiCartRedirectUrl(window.cartDrawerApp.getCartItems());
        if (redirectFromState) return redirectFromState;
      }

      try {
        const response = await fetchWithTimeout('/cart.js');
        if (response.ok) {
          const cart = await response.json();
          return getMultiCartRedirectUrl(cart.items || []);
        }
      } catch (error) {
        console.error('Error checking cart for multi item:', error);
      }

      if (window.shopifyCart && Array.isArray(window.shopifyCart)) {
        return getMultiCartRedirectUrl(window.shopifyCart);
      }

      return null;
    }
  
    close() {
      this.classList.remove('active');
      if (typeof removeTrapFocus !== 'undefined') {
        removeTrapFocus(this.activeElement);
      }
      document.body.classList.remove('overflow-hidden');
    }
  
    setActiveElement(element) {
      this.activeElement = element;
    }
  
    renderContents(parsedState) {
      if (window.cartDrawerApp?.refreshCart) {
        window.cartDrawerApp.refreshCart();
      }
  
      if (window.cartDrawerApp?.applyPendingConfiguration) {
        setTimeout(() => {
          window.cartDrawerApp.applyPendingConfiguration();
        }, 150);
      }
  
      setTimeout(() => this.open(), 100);
    }
  
    getSectionsToRender() {
      return [];
    }
  }
  
  customElements.define('cart-drawer', CartDrawer);
  
  // ============================================================================
  // HELPER FUNCTIONS
  // ============================================================================
  
  window.openCartDrawer = function() {
    document.querySelector('cart-drawer')?.open();
  };
  
  window.closeCartDrawer = function() {
    document.querySelector('cart-drawer')?.close();
  };
  
  // ============================================================================
  // PERFORMANCE & STABILITY UTILITIES
  // ============================================================================
  
  async function fetchWithTimeout(url, options = {}, timeout = REQUEST_TIMEOUT) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);
  
    try {
      const response = await fetch(url, {
        ...options,
        signal: controller.signal
      });
      clearTimeout(timeoutId);
      return response;
    } catch (error) {
      clearTimeout(timeoutId);
      if (error.name === 'AbortError') {
        throw new Error('Request timeout');
      }
      throw error;
    }
  }
  
  async function retryRequest(requestFn, maxRetries = 2, delay = 300) {
    for (let i = 0; i <= maxRetries; i++) {
      try {
        return await requestFn();
      } catch (error) {
        if (i === maxRetries) throw error;
        await new Promise(resolve => setTimeout(resolve, delay * (i + 1)));
      }
    }
  }
  
  // ============================================================================
  // VANILLA JS CART DRAWER APP
  // ============================================================================
  
  function escapeHtml(str) {
    if (str == null) return '';
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }
  
  function CartDrawerApp() {
    const el = document.getElementById('cart-drawer-app');
    if (!el) return null;
  
    const state = {
      loading: false,
      processing: false,
      subscription: true,
      multiQuantity: 1,
      cartItems: [],
      freeShippingThreshold: 35000,
      processingTimeout: null,
      requestQueue: Promise.resolve(),
      pendingConfiguration: null,
      upsellOpen: true
    };
  
    function getFilteredCartItems() {
      return state.cartItems.filter(item => !SUBSCRIPTION_SKUS.includes(item.sku));
    }
  
    function getAvailableUpsellProducts() {
      const cartProductIds = state.cartItems.map(item => item.product_id);
      const cartSkus = state.cartItems.map(item => item.sku);
      return UPSELL_PRODUCTS.filter(p =>
        !cartProductIds.includes(p.product_id) && !cartSkus.includes(p.sku)
      );
    }
  
    function getCartOriginalPrice() {
      return state.cartItems.reduce((sum, item) => sum + item.original_line_price, 0);
    }
  
    function getCartFinalPrice() {
      if (state.subscription) {
        const discountPercent = state.multiQuantity === 1 ? 0.10 : 0.15;
        return Math.ceil(getCartOriginalPrice() * (1 - discountPercent));
      }
      return getCartOriginalPrice();
    }
  
    function getSubscriptionDiscount() {
      if (state.subscription) {
        const discountPercent = state.multiQuantity === 1 ? 0.10 : 0.15;
        return Math.ceil(getCartOriginalPrice() * discountPercent);
      }
      return 0;
    }
  
    function getMonthlyPlanPrice() {
      return state.multiQuantity === 3
        ? getCartFinalPrice() / 0.85 / 3 * 0.9
        : getCartFinalPrice();
    }
  
    function getTrimestralPlanPrice() {
      return state.multiQuantity === 3
        ? getCartFinalPrice() / 3
        : getCartFinalPrice() / 0.9 * 0.85;
    }
  
    function getShouldShowProducts() {
      const filtered = getFilteredCartItems();
      if (filtered.length === 0) return true;
      if (filtered.length === 1) {
        return SUBSCRIPTION_SKUS.includes(filtered[0].sku);
      }
      return false;
    }
  
    function getCheckoutButtonText() {
      return getShouldShowProducts() ? 'VER PRODUTOS' : 'COMPRAR';
    }
  
    function formatPrice(price) {
      return new Intl.NumberFormat('pt-BR', {
        currency: 'BRL',
        style: 'currency'
      }).format(price / 100);
    }
  
    function productDescriptionFromTags(item) {
      try {
        const tags = item.tags || '';
        if (tags) {
          for (const tag of tags.split(',')) {
            const trimmed = tag.trim();
            if (trimmed.toLowerCase().indexOf('description|') >= 0) {
              return trimmed.replace(/description\|/gi, '');
            }
          }
        }
        return '';
      } catch (e) {
        return '';
      }
    }
  
    function calculateFreeShippingProgress() {
      const final = getCartFinalPrice();
      return final >= state.freeShippingThreshold
        ? 100
        : (final / state.freeShippingThreshold) * 100;
    }
  
    function getFreeShippingRemaining() {
      return ((state.freeShippingThreshold - getCartFinalPrice()) / 100).toFixed(2);
    }
  
    function setProcessing(value) {
      state.processing = value;
  
      if (state.processingTimeout) {
        clearTimeout(state.processingTimeout);
        state.processingTimeout = null;
      }
  
      if (value) {
        state.processingTimeout = setTimeout(() => {
          state.processing = false;
          state.processingTimeout = null;
          render();
        }, PROCESSING_SAFETY_TIMEOUT);
      }
      render();
    }
  
    function queueRequest(requestFn) {
      state.requestQueue = state.requestQueue
        .then(() => requestFn())
        .catch(error => console.error('Queued request error:', error));
      return state.requestQueue;
    }
  
    function closeDrawer() {
      window.closeCartDrawer();
    }
  
  
    function applyPendingConfiguration() {
      if (!state.pendingConfiguration) return;
  
      const { subscription, multiQuantity } = state.pendingConfiguration;
      state.subscription = subscription;
      state.multiQuantity = multiQuantity;
      state.pendingConfiguration = null;
      render();
    }
  
    function buildMarkup() {
      const filtered = getFilteredCartItems();
      const isEmpty = filtered.length === 0;
  
      let html = '';
  
      if (state.processing) {
        html += `
        <div class="cart-drawer-loading-overlay">
          <div class="loading-spinner">
            <div></div><div></div><div></div>
          </div>
        </div>`;
      }
  
      html += `
        <div class="drawer__header">
          <h2 class="drawer__heading">Carrinho</h2>
          <button class="drawer__close" type="button" data-action="close" aria-label="Fechar">×</button>
        </div>`;
  
      if (isEmpty) {
        html += `
        <div class="drawer__empty-state">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#c2c2c2" stroke-width="1">
            <circle cx="9" cy="21" r="1"></circle>
            <circle cx="20" cy="21" r="1"></circle>
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
          </svg>
          <h3>Seu carrinho está vazio</h3>
          <p>Adicione produtos para começar</p>
          <button class="btn btn-primary" data-action="close">Continuar comprando</button>
        </div>`;
      } else {
        const progress = calculateFreeShippingProgress();
        const remaining = getFreeShippingRemaining();
  
        html += `
        <div class="drawer__content">
          <div class="drawer-free-shipping-bar">
            <div class="shipping-progress-container">
              <div class="shipping-progress" style="width:${progress}%"></div>
            </div>
            <p class="shipping-text${remaining > 0 ? '' : ' shipping-achieved'}">
              ${remaining > 0
                ? `Faltam <b>${escapeHtml(formatPrice(remaining * 100))}</b> para o frete grátis`
                : 'Você ganhou frete grátis!'}
            </p>
          </div>
  
          <div class="drawer-cart-items">`;
  
        filtered.forEach(item => {
          const imgUrl = item.image || item.featured_image || '';
          const desc = productDescriptionFromTags(item);
          html += `
            <div class="drawer-cart-item" data-item-id="${item.id}">
              <div class="item-image" style="background-image:url(${escapeHtml(imgUrl)})"></div>
              <div class="item-details">
                <h4>${escapeHtml(item.title)}${state.subscription && item.quantity > 1 ? ` <span class="item-qty-label">x${item.quantity}</span>` : ''}</h4>
                <p class="item-subtitle">${desc}</p>
              </div>
              <div class="item-quantity-price">
                <p class="item-price">${formatPrice(item.original_line_price)}</p>
                ${!state.subscription ? `
                <div class="quantity-controls">
                  <button type="button" data-action="decrease" data-item-id="${item.id}">−</button>
                  <span>${item.quantity}</span>
                  <button type="button" data-action="increase" data-item-id="${item.id}">+</button>
                </div>` : ''}
              </div>
              <button class="item-remove" type="button" data-action="remove" data-item-id="${item.id}">×</button>
            </div>`;
        });
  
        html += `
          </div>`;
  
        const upsellProducts = getAvailableUpsellProducts();
        if (upsellProducts.length > 0) {
          html += `
          <div class="drawer-upsell">
            <button type="button" class="upsell-toggle" data-action="toggle-upsell">
              <span>Adicione mais produtos</span>
              <svg class="upsell-chevron${state.upsellOpen ? ' open' : ''}" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </button>
            <div class="upsell-body${state.upsellOpen ? ' open' : ''}">
              <div class="upsell-products">`;
          upsellProducts.forEach(product => {
            html += `
                <div class="upsell-card">
                  <img class="upsell-card-img" src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">
                  <div class="upsell-card-info">
                    <span class="upsell-card-name">${escapeHtml(product.title)}</span>
                    <span class="upsell-card-price">${formatPrice(product.price)}</span>
                  </div>
                  <button type="button" class="upsell-card-add" data-action="add-upsell" data-variant-id="${product.variant_id}">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                  </button>
                </div>`;
          });
          html += `
              </div>
            </div>
          </div>`;
        }
  
        html += `
          <div class="drawer-purchase-type">
            <h3>ESCOLHER FORMATO DE COMPRA</h3>
            <div class="purchase-type-buttons">
              <button type="button" data-action="set-subscription" data-value="true" class="${state.subscription ? 'active' : ''}">
                <span class="badge">ATÉ 15% OFF</span>
                ASSINATURA
              </button>
              <button type="button" data-action="set-subscription" data-value="false" class="${!state.subscription ? 'active' : ''}">
                COMPRA ÚNICA
              </button>
            </div>
          </div>`;
  
        if (state.subscription) {
          const days = state.multiQuantity === 1 ? '30' : '90';
          const discountPct = state.multiQuantity === 1 ? '10%' : '15%';
  
          html += `
          <div class="drawer-plan-selector">
            <h3>ESCOLHA SEU PLANO</h3>
            <div class="plan-buttons">
              <div class="plan-option">
                <button type="button" data-action="set-quantity" data-value="1" class="${state.multiQuantity === 1 ? 'active' : ''}">
                  <span class="badge-popular">10% OFF</span>
                  MENSAL
                </button>
                <span class="plan-price">${formatPrice(getMonthlyPlanPrice())}/mês</span>
              </div>
              <div class="plan-option">
                <button type="button" data-action="set-quantity" data-value="3" class="${state.multiQuantity === 3 ? 'active' : ''}">
                  <span class="badge-popular">15% OFF</span>
                  TRIMESTRAL
                </button>
                <span class="plan-price">${formatPrice(getTrimestralPlanPrice())}/mês</span>
              </div>
            </div>
          </div>
  
          <div class="drawer-subscription-info">
            <h4>PLANO DE ASSINATURA SETYOU</h4>
            <p>Você receberá a cada ${days} dias</p>
            <ul>`;
          filtered.forEach(item => {
            html += `
              <li>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                ${escapeHtml(String(item.quantity))} ${escapeHtml(item.title)}
              </li>`;
          });
          html += `
              <li>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                ${discountPct} de desconto
              </li>
            </ul>
          </div>`;
        }
  
        const cartOriginal = getCartOriginalPrice();
        const cartFinal = getCartFinalPrice();
        const subDiscount = getSubscriptionDiscount();
        const discountLabel = state.multiQuantity === 1 ? '10%' : '15%';
  
        html += `
          <div class="drawer-summary">
            <div class="summary-total">
              <div class="total-row">
                <span class="total-label">TOTAL</span>
                <div class="total-prices">
                  ${state.subscription ? `<span class="price-original">${formatPrice(cartOriginal)}</span>` : ''}
                  <span class="price-final">${formatPrice(cartFinal)}</span>
                  ${state.subscription ? `<span class="badge">${discountLabel} OFF</span>` : ''}
                </div>
              </div>
              <p class="installments">ou 3x de ${formatPrice(cartFinal / 3)}</p>
            </div>
          </div>`;
  
        if (state.subscription) {
          html += `
          <p class="subscription-terms">
            Cancele ou edite a qualquer momento antes da próxima renovação.
            <a href="/pages/assinatura" target="_blank">Confira nossos termos</a>.
          </p>`;
        }
  
        html += `
        </div>
  
        <button class="btn btn-checkout" type="button" data-action="checkout">
          ${getCheckoutButtonText()}
        </button>`;
      }
  
      return html;
    }
  
  function render() {
      // 1. Constrói o HTML do carrinho
      el.innerHTML = buildMarkup();
  
      // 2. Renderiza o painel lateral de upsell (desktop)
      renderUpsellAside();
  
      // 3. Sincroniza a classe 'is-empty' do elemento pai (<cart-drawer>)
      const cartDrawerElement = document.querySelector('cart-drawer');
      if (cartDrawerElement) {
        const filteredItems = getFilteredCartItems();
        if (filteredItems.length === 0) {
          cartDrawerElement.classList.add('is-empty');
        } else {
          cartDrawerElement.classList.remove('is-empty');
        }
      }
    }
  
    function renderUpsellAside() {
      const aside = document.getElementById('cart-drawer-upsell-aside');
      if (!aside) return;
  
      const filtered = getFilteredCartItems();
      const products = getAvailableUpsellProducts();
  
      if (filtered.length === 0 || products.length === 0) {
        aside.innerHTML = '';
        return;
      }
  
      let html = `<h3 class="upsell-aside-title">Adicione mais produtos</h3>`;
      products.forEach(product => {
        html += `
          <div class="upsell-card">
            <img class="upsell-card-img" src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">
            <div class="upsell-card-info">
              <span class="upsell-card-name">${escapeHtml(product.title)}</span>
              <span class="upsell-card-price">${formatPrice(product.price)}</span>
            </div>
            <button type="button" class="upsell-card-add" data-action="add-upsell" data-variant-id="${product.variant_id}" aria-label="Adicionar ${escapeHtml(product.title)}">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
            </button>
          </div>`;
      });
      aside.innerHTML = html;
    }
  
    async function refreshCart() {
      try {
        const cart = await retryRequest(async () => {
          const response = await fetchWithTimeout('/cart.js');
          if (!response.ok) throw new Error('Cart fetch failed');
          return await response.json();
        });
  
        const updates = {};
        for (const item of cart.items) {
          if (SUBSCRIPTION_SKUS.includes(item.sku)) {
            updates[item.id] = 0;
          }
        }
  
        if (Object.keys(updates).length > 0) {
          await retryRequest(async () => {
            const response = await fetchWithTimeout('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates })
            });
            if (!response.ok) throw new Error('Cart update failed');
          });
  
          const newCart = await retryRequest(async () => {
            const response = await fetchWithTimeout('/cart.js');
            if (!response.ok) throw new Error('Cart fetch failed');
            return await response.json();
          });
          state.cartItems = newCart.items;
        } else {
          state.cartItems = cart.items;
        }
  
        applyPendingConfiguration();
        render();
      } catch (error) {
        console.error('Error refreshing cart:', error);
      }
    }
  
    async function decreaseItemQuantity(item) {
      if (state.processing) return;
      return queueRequest(async () => {
        setProcessing(true);
        try {
          const newQty = item.quantity > 1 ? item.quantity - 1 : 0;
          await updateCartQuantity(item.id, newQty);
        } catch (e) {
          console.error('Error decreasing quantity:', e);
        } finally {
          setProcessing(false);
        }
      });
    }
  
    async function increaseItemQuantity(item) {
      if (state.processing) return;
      return queueRequest(async () => {
        setProcessing(true);
        try {
          await updateCartQuantity(item.id, item.quantity + 1);
        } catch (e) {
          console.error('Error increasing quantity:', e);
        } finally {
          setProcessing(false);
        }
      });
    }
  
    async function removeItemFromCart(id) {
      return queueRequest(async () => {
        setProcessing(true);
        try {
          await updateCartQuantity(id, 0);
        } catch (e) {
          console.error('Error removing item:', e);
        } finally {
          setProcessing(false);
        }
      });
    }
  
    async function updateCartQuantity(id, quantity) {
      try {
        await retryRequest(async () => {
          const response = await fetchWithTimeout('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: { [id]: quantity } })
          });
          if (!response.ok) throw new Error('Cart update failed');
        });
        await refreshCart();
      } catch (e) {
        console.error('Error updating cart:', e);
      }
    }
  
    async function setSubscription(value) {
      if (state.subscription === value || state.processing) return;
  
      return queueRequest(async () => {
        setProcessing(true);
        try {
          state.multiQuantity = 1;
          const updates = {};
          for (const item of state.cartItems) {
            if (!SUBSCRIPTION_SKUS.includes(item.sku) && item.quantity !== 1) {
              updates[item.id] = 1;
            }
          }
          if (Object.keys(updates).length > 0) {
            await updateCartQuantities(updates);
          }
          state.subscription = value;
        } catch (e) {
          console.error('Error setting subscription:', e);
        } finally {
          setProcessing(false);
        }
      });
    }
  
    async function setQuantity(value) {
      if (state.processing || value > 4) return;
  
      return queueRequest(async () => {
        setProcessing(true);
        try {
          state.multiQuantity = value;
          if (state.subscription) {
            const updates = {};
            for (const item of state.cartItems) {
              if (!SUBSCRIPTION_SKUS.includes(item.sku) && item.quantity !== value) {
                updates[item.id] = value;
              }
            }
            if (Object.keys(updates).length > 0) {
              await updateCartQuantities(updates);
            }
          }
        } catch (e) {
          console.error('Error setting quantity:', e);
        } finally {
          setProcessing(false);
        }
      });
    }
  
    async function updateCartQuantities(updates) {
      try {
        await retryRequest(async () => {
          const response = await fetchWithTimeout('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
          if (!response.ok) throw new Error('Cart update failed');
        });
        await refreshCart();
      } catch (e) {
        console.error('Error updating cart quantities:', e);
        await refreshCart();
      }
    }
  
    function handleCheckoutClick() {
      if (getShouldShowProducts()) {
        window.location.href = 'https://setyou.com.br/collections/vitrine';
      } else {
        navigateToCheckout();
      }
    }
  
    async function navigateToCheckout() {
      if (state.processing || state.cartItems.length === 0) return;
  
      return queueRequest(async () => {
        setProcessing(true);
        try {
          if (state.subscription) {
            await applySubscriptionProperties();
          }
          const discountCode = state.subscription
            ? (state.multiQuantity === 1 ? DISCOUNT_CODES.monthly : DISCOUNT_CODES.quarterly)
            : null;
  
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = '/cart';
          form.style.display = 'none';
  
          const checkoutInput = document.createElement('input');
          checkoutInput.type = 'hidden';
          checkoutInput.name = 'checkout';
          checkoutInput.value = '';
          form.appendChild(checkoutInput);
  
          if (discountCode) {
            const discountInput = document.createElement('input');
            discountInput.type = 'hidden';
            discountInput.name = 'discount';
            discountInput.value = discountCode;
            form.appendChild(discountInput);
          }
  
          document.body.appendChild(form);
          form.submit();
        } catch (e) {
          console.error('Error navigating to checkout:', e);
          setProcessing(false);
        }
      });
    }
  
    async function addItemToCart(variantId) {
      return queueRequest(async () => {
        setProcessing(true);
        try {
          await retryRequest(async () => {
            const response = await fetchWithTimeout('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
            });
            if (!response.ok) throw new Error('Add to cart failed');
          });
          await refreshCart();
        } catch (e) {
          console.error('Error adding item:', e);
        } finally {
          setProcessing(false);
        }
      });
    }
  
    async function applySubscriptionProperties() {
      const cart = await retryRequest(async () => {
        const response = await fetchWithTimeout('/cart.js');
        if (!response.ok) throw new Error('Cart fetch failed');
        return await response.json();
      });
  
      const cartItems = cart.items;
  
      await retryRequest(async () => {
        const response = await fetchWithTimeout('/cart/clear.js', { method: 'POST' });
        if (!response.ok) throw new Error('Cart clear failed');
      });
  
      const frequency = state.multiQuantity === 1 ? 'M' : 'Q';
      const frequencyLabel = state.multiQuantity === 1 ? 'Mensal' : 'Trimestral';
      const subscriptionId = state.multiQuantity === 1
        ? SUBSCRIPTION_IDS.monthly
        : SUBSCRIPTION_IDS.quarterly;
  
      await retryRequest(async () => {
        const response = await fetchWithTimeout('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: subscriptionId,
            quantity: 1,
            properties: {
              '_frequency': frequency,
              '_Frequência da assinatura': frequencyLabel
            }
          })
        });
        if (!response.ok) throw new Error('Add subscription flag failed');
      });
  
      for (const item of cartItems) {
        if (SUBSCRIPTION_SKUS.includes(item.sku)) continue;
        await retryRequest(async () => {
          const response = await fetchWithTimeout('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: item.id,
              quantity: item.quantity,
              properties: {
                '_frequency': frequency,
                '_Frequência da assinatura': frequencyLabel
              }
            })
          });
          if (!response.ok) throw new Error('Add item failed');
        });
      }
    }
  
    function handleClick(e) {
      const target = e.target.closest('[data-action]');
      if (!target) return;
  
      const action = target.getAttribute('data-action');
      if (action === 'close') {
        closeDrawer();
        return;
      }
      if (action === 'checkout') {
        handleCheckoutClick();
        return;
      }
      if (action === 'set-subscription') {
        const val = target.getAttribute('data-value') === 'true';
        setSubscription(val);
        return;
      }
      if (action === 'set-quantity') {
        const val = parseInt(target.getAttribute('data-value'), 10);
        setQuantity(val);
        return;
      }
      if (action === 'remove') {
        const id = parseInt(target.getAttribute('data-item-id'), 10);
        removeItemFromCart(id);
        return;
      }
      if (action === 'decrease' || action === 'increase') {
        const id = parseInt(target.getAttribute('data-item-id'), 10);
        const item = state.cartItems.find(i => i.id === id);
        if (item) {
          if (action === 'decrease') decreaseItemQuantity(item);
          else increaseItemQuantity(item);
        }
        return;
      }
      if (action === 'toggle-upsell') {
        state.upsellOpen = !state.upsellOpen;
        render();
        return;
      }
      if (action === 'add-upsell') {
        const variantId = parseInt(target.getAttribute('data-variant-id'), 10);
        if (variantId) addItemToCart(variantId);
        return;
      }
    }
  
    document.addEventListener('cart-drawer:configure', (event) => {
      const { subscription, multiQuantity } = event.detail;
      state.pendingConfiguration = { subscription, multiQuantity };
      applyPendingConfiguration();
    });
  
    if (window.shopifyCart?.length > 0) {
      state.cartItems = window.shopifyCart;
    }
  
    render();
    el.setAttribute('data-ready', 'true');
  
    el.addEventListener('click', handleClick);
    const upsellAside = document.getElementById('cart-drawer-upsell-aside');
    if (upsellAside) upsellAside.addEventListener('click', handleClick);
  
    // Converte scroll vertical do mouse em horizontal na lista de upsell (desktop)
    el.addEventListener('wheel', function(e) {
      const upsellRow = e.target.closest('.upsell-products');
      if (!upsellRow) return;
      if (e.deltaY === 0) return;
      if (upsellRow.scrollWidth <= upsellRow.clientWidth) return;
      e.preventDefault();
      upsellRow.scrollLeft += e.deltaY;
    }, { passive: false });
  
    return {
      refreshCart,
      applyPendingConfiguration,
      getCartItems: () => state.cartItems,
      addItemToCart
    };
  }
  
  function initCartDrawerApp() {
    window.cartDrawerApp = CartDrawerApp();
    loadPromoMultiCatalog();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawerApp);
  } else {
    initCartDrawerApp();
  }
  
  // ============================================================================
  // EVENT LISTENERS
  // ============================================================================
  
  document.addEventListener('product:added-to-cart', async () => {
    if (window.cartDrawerApp?.refreshCart) {
      await window.cartDrawerApp.refreshCart();
    }
    setTimeout(() => window.openCartDrawer(), 100);
  });
  
  document.addEventListener('cart:updated', async () => {
    if (window.cartDrawerApp?.refreshCart) {
      await window.cartDrawerApp.refreshCart();
    }
  });
  
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      const cartLinks = document.querySelectorAll('a[href="/cart"], a[href*="/cart?"]');
      cartLinks.forEach(link => {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          window.openCartDrawer();
        });
      });
    }, 500);
  });
  
  }
  